// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_1yhI8","avatar":"index_avatar_3i1GL"};